import get from 'lodash/get';
import sortBy from 'lodash/sortBy';
import { CommerceAddress, SoldToAddress, TasstaxIdLabel } from '@css-xp/graphtypes/src/generated-types-new';

export const getTaxInformationFromAddress = (address: CommerceAddress | SoldToAddress | null | undefined) => {
  if (address?.taxIds && address?.taxIds?.length > 0) {
    const billToTaxIds = sortBy([...address.taxIds], ['label']);

    let taxIdLabels: TasstaxIdLabel[] | undefined;
    const taxLabels = address?.taxLabels;
    if (taxLabels && taxLabels.length > 0) {
      taxIdLabels = taxLabels[0]?.taxIdLabels as TasstaxIdLabel[];
    }

    return billToTaxIds?.map((taxId) => {
      const taxIdLabel = taxIdLabels?.filter(({ type }) => type && type === taxId?.label);
      const displayTaxLabel = get(taxIdLabel, '[0].displayName', '');
      return {
        taxDisplayName: displayTaxLabel,
        label: `${displayTaxLabel} Tax ID`,
        value: taxId?.id,
        taxExempt: taxId?.taxExempt ? 'Yes' : 'No',
      };
    });
  }

  if (address?.taxId) {
    return [
      {
        taxDisplayName: 'Tax ID',
        label: 'Tax ID',
        value: address?.taxId,
        taxExempt: get(address, 'taxExempt') ? 'Yes' : 'No',
      },
    ];
  }

  return [];
};

export const getTaxLabelInformationFromAddress = (address: CommerceAddress | SoldToAddress | null | undefined) => {
  const taxExemptionStatus = get(address, 'taxExempt') ? 'Yes' : 'No';
  if (address?.taxLabels && address.taxLabels.length > 0) {
    const taxIds = address?.taxIds ?? [];
    const taxIdLabels = address.taxLabels[0]?.taxIdLabels;

    const taxIdsWithDisplayName = taxIdLabels?.filter((tax) => tax?.displayName);
    const taxIdsWithDisplayNameSorted = sortBy(taxIdsWithDisplayName, ['displayName']);

    return taxIdsWithDisplayNameSorted?.length
      ? taxIdsWithDisplayNameSorted?.map((tax) => {
          const taxId = taxIds.filter((taxId) => taxId?.label === tax?.type);
          const taxExemption = taxId.length > 0 ? taxId[0]?.taxExempt : Boolean(get(address, 'taxExempt'));
          const taxExemptionStatus = taxExemption ? 'Yes' : 'No';
          return {
            taxDisplayName: tax?.displayName,
            taxExempt: taxExemptionStatus,
          };
        })
      : [];
  }
  return [{ taxDisplayName: '', taxExempt: taxExemptionStatus }];
};
